export enum RefundType {
  NONE = 0,
  CASH = 1,
  CREDIT = 2,
}
